<template>
	<div class="wrap">
		<div class="bonus-top">
			<!-- <div class="text-top">奖金周期：{{ cycle | cycleStr }}</div> -->
			<!-- <slider :list="head_list" :valueKey="'amount'" :limit='5' :color="'#7d51d6'"></slider> -->
			<div class="slider-item">
				<div class="head">个人奖金</div>
				<div class="main">{{ task_curr.currency_name }}：<span>{{ head_data.transAmount || 0 }}</span>币</div>
			</div>

			<div class="bonus-top-bottom">
				<div>
					<span>年份：</span>
					<el-select class="top-choose" v-model="year" clearable placeholder="请选择">
						<el-option v-for="item in bonusYearOptions" :key="item" :value="item">
						</el-option>
					</el-select>
					<span>周期：</span>
					<el-select class="top-choose" v-model="cycleId" clearable placeholder="请选择" z-noData-text="请先选择年份">
						<el-option v-for="item in bonusCycleOptions" :key="item.id" :label="item.cycle_number_show" :value="item.id">
						</el-option>
					</el-select>
					<div class='front-btn green shift' @click="search()">查询</div>
				</div>
			</div>
		</div>
		<div class="bonus-bottom">
			<div class="bonus-bottom-title">结算明细</div>
			<accountsTable @bigFresh="bigFresh" :dataList="dataList"></accountsTable>
		</div>

		<z-pagination class="inside" @getPage="search" :data='data'></z-pagination>
	</div>
</template>
<script type="text/ecmascript-6">
	import accountsTable from 'src/components/accountsTable.vue'
	import slider from "src/components/asset-slider.vue";

	import { mapGetters, mapState } from 'vuex'
	import { getBonusCycleOptions } from "src/control/common.js";

	export default {
		components: {
			accountsTable,
			slider,
		},
		data() {
			return {
				// newestInfo: {},  //最新的结算信息
				head_data:[],   //豆腐块

				year:"",  //选项  年
				cycleId:"",  //选项 周期
				data:{},  //列表数据

				bonusCycleOptions:[],  // 周期选项
			}
		},
		computed: {
			...mapGetters(["bonusYearOptions","task_curr"]),  //周期年份列表
			dataList(){
				return this.data.list;
			},
			// cycle(){   //头部 cycle对象
			// 	return this.head_data.cycleDetail || {};
			// },

			// head_list(){
			// 	let list = this.head_data.currencyList || [];
			// 	let num_list = this.head_data.currPersonalDetailList || [];
			// 	return list.length !== 0?list.map(item=>{
			// 		let num = 0;
			// 		num_list.some(curr=>{
			// 			return curr.currency_id == item.id && (num = curr.trans_amount);
			// 		});
			// 		return {
			// 			currency_name:item.currencyName,
			// 			amount:num,
			// 			id:item.id,
			// 		}
			// 	}):num_list.filter(curr=>{
			// 		return curr.detail_type != 20;
			// 	})
			// 	.map(curr=>{
			// 		return {
			// 			currency_name:curr.currency_name,
			// 			amount:curr.trans_amount,
			// 			id:curr.currency_id,
			// 		}
			// 	});
			// },

		},
		watch: {
			year(val){
				this.bonusCycleOptions = getBonusCycleOptions(val);
				this.cycleId = "";
			},
		},
		created() {
			this.bigFresh();
		},

		methods: {
			bigFresh(){
				this.fresh();
				this.$func.getBonusCycle(true);  //获取周期情况
				this.$func.getUserInfo(info=>{
					let url = `api/clerk/bonus_sum/${info.id}`
					this.$http.get(url).then(res=>{
						if(res.status == 200){
							this.head_data = res.res_data;
						}
					});
				});
				console.log("大刷新了");
			},

			getBonusTop(){

			},

			// getNowCycleInfo() {  //拉取豆腐块的值
			// 	let id = this.dataList[0].cycle_detail_id;
			// 	let url = `api/clerk/curr_personal_detail/${id}`;
			// 	this.newestInfo = {...this.dataList[0]};
			// 	this.$http.get(url).then(res => {
			// 		this.head_data = res.data.data;
			// 		if(this.newestInfo.confirm_time){
			// 			this.head_data.forEach(item=>{
			// 				item.trans_number_yuan = 0;
			// 			});
			// 		}
			// 	});
			// },
			fresh(obj = {},func){  //拉取列表数据
				if(typeof obj == "function"){
					func = obj;
					obj = {};
				}
				let url = "api/clerk/curr_personal_summary_detail/new";
				this.$http.get(url,{params:obj}).then(res=>{
					if(res.status == 200){
						this.data = res.res_data;
					}
				});
			},
			search(page){  //搜索
				let obj = {
					page:page,
					year:this.year,
					cycle_detail_id:this.cycleId
				};
				this.fresh(obj);
			},

		},

	};

</script>

<style lang="less" scoped>
	@import "~src/assets/less/var.less";
	@box_h:90px;  //方块高
	@box_w:150px;  //方块宽
	@align:30px;   //对齐值
	@color:#7d51d6;

	.slider-view{
		width: (@box_w + @align)*5 !important;
	}
	.slider-item{
		display: inline-block;
		// margin: 0 @align/2;
		margin-right:15px;
		box-sizing: border-box;
		width:@box_w;
		height:@box_h;
		border-radius: 8px;
		border:1px solid transparent;
		border-color:@color;
		overflow: hidden;

		.head{
			font-size: 14px;
			font-weight: 600;
			color:#fff;
			padding-left: 15px;
			height: 25px;
			line-height: 25px;
			text-align: left;
			background:@color;
		}

		.main{
			height:calc(~"100% - 25px");
			padding-top: 18px;
			text-align: center;
			font-size:12px;
			color:#6471a4;
			color:@color;
			span{
				font-size:16px;
				color:@blue;
				font-weight:600;
			}
		}

	}


	.wrap {
		background: #ffffff;
		box-shadow: 0px 0px 4px 0px rgba(127, 127, 127, 0.50);
		height: 100%;
		position: relative;
	}

	.bonus-top {
		padding: 20px 20px 0;
		.text-top {
			// color: #333;
			font-size: 14px;
			margin-bottom: 10px;
			color: #01b6ad;
		}
	}

// .bonus-top li {
// 	display: inline-block;
// 	border: 1px solid #d2deee;
// 	width: 226px;
// 	height: 138px;
// 	position: relative;
// 	margin-right: 10px;
// 	margin-bottom: 10px;
// }

// .bonus-top li>span {
// 	font-size: 12px;
// 	color: #808080;
// 	letter-spacing: 1.33px;
// 	text-align: left;
// 	position: absolute;
// 	left: 10px;
// 	top: 10px;
// }

// .bonus-top li>p {
// 	font-size: 12px;
// 	color: #01b6ad;
// 	letter-spacing: 0.99px;
// 	text-align: center;
// 	margin-top: 42px;
// }

// .bonus-top li>div {
// 	height: 36px;
// 	font-size: 36px;
// 	line-height: 36px;
// 	color: #ff6b6b;
// 	letter-spacing: 4px;
// 	text-align: center;
// 	margin-top: 0px;
// }

.bonus-top-bottom {
	height: 25px;
	margin: 15px 0 11px;
	span{
		margin-left: 15px;
		font-size: 12px;
	}
}

.bonus-top-bottom>div {
	float: right;
	font-size: 0;
}


// .bonus-top-bottom>p>.listDown {
// 	box-sizing: border-box;
// 	border: 1px solid #d9d9d9;
// 	border-radius: 2px;
// 	width: 98px;
// 	height: 23px;
// 	margin: 0 10px 0 20px;
// 	font-size: 12px;
// 	color: #808080;
// 	letter-spacing: 0.99px;
// 	text-align: left;
// }

.bonus-bottom {
	position: relative;
	height:calc(~"100% - 215px - 11px");
}

.bonus-bottom-title {
	position: absolute;
	top: -30px;
	left: 31px;
	width: 80px;
	height: 28px;
	border-bottom: 2px solid #01b6ad;
	font-size: 14px;
	line-height: 28px;
	color: #01b6ad;
	letter-spacing: 1.55px;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// page-personalBonus.vue?c8aa0c24